import {Component, Inject, OnInit} from '@angular/core';
import {NotificationsService} from '../notifications.service';
import {Notifications} from '../notifications.enum';
import {Employee} from '../../../settings/model/employee';

@Component({
	selector: 'tt-on-call-notification',
	templateUrl: './on-call-notification.component.html',
	styleUrls: ['./on-call-notification.component.scss']
})
export class OnCallNotificationComponent implements OnInit {

	onCallEmployee: Employee;

	constructor(private notificationsService: NotificationsService,
				@Inject('$rootScope') private rootScopeService: ng.IRootScopeService) {

		rootScopeService.$on('makeAPICalls', () => this.updateOnCallEmployee());
		rootScopeService.$on('updateOnCallStatus', () => this.updateOnCallEmployee());
	}

	ngOnInit(): void {
		this.updateOnCallEmployee();
	}

	updateOnCallEmployee(): void {
		this.notificationsService
			.getOnCallEmployee()
			.subscribe((employee: Employee) => this.onCallEmployee = employee);
	}

	isVisible(): boolean {
		return this.notificationsService.isNotificationAvailable(Notifications.ON_CALL);
	}

	closeNotification(): void {
		this.notificationsService.closeNotification(Notifications.ON_CALL);
	}


}



// WEBPACK FOOTER //
// ./src/app/my-time/notifications/on-call-notification/on-call-notification.component.ts